import { FC, ReactNode, CSSProperties } from 'react';
import ButtonComponent from './Style';

interface IProps {
    action?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    mode: 'flat' | 'normal';
    children?: ReactNode;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset' | undefined;
    hasShadow?: boolean;
    textColor?: string;
    id: string;
    style?: CSSProperties;
}
const Button: FC<IProps> = ({
    action,
    mode,

    disabled,
    type,
    hasShadow = false,
    textColor = '',
    id,
    children,
    style
}) => {
    const buttonStyles: React.CSSProperties = {
        ...(textColor && { color: textColor }),
        ...style // Add this line
    };
    return (
        <ButtonComponent
            hasShadow={hasShadow}
            onClick={action}
            mode={mode}
            type={type}
            disabled={disabled}
            textColor={textColor}
            id={id}
            style={style}
        >
            {children}
        </ButtonComponent>
    );
};

export default Button;
